import PlanService from "src/services/PlanService";
import ModuleCreator from "src/store/ModuleCreator";
import { types as projectType } from "@/store/modules/Project.module";

export const types = {
	REMOVE: "plan/remove",
	GET_PAYMENT_URL: "",
};
export const params = {
	project_id: "",
	title: "",
	description: "",
	additional_text: "",
	additional: "",
	type: 1,
	amount: "",
	price: "",
	custom_price:false,
  currency:"ILS"

};

/**
 @namespace
 @property  {object} module,
 @property  {object} module.state,
 @property  {object} modules.plan,
 @property  {array}  modules.plans
 **/

const module = {
	state: {
		selectedPlan: null,
	},
	mutations: {
		setSelectedPlan (state, payload) { state.selectedPlan = payload; },
	},
	getters: {},
	actions: {
		[types.GET_PAYMENT_URL] (context, planData) {
			return PlanService.getPayMentLink(planData).then((response) => {
				return response.data;
			});
		},
		[types.REMOVE] (context, plan) {
			return PlanService.remove(plan.id).then((response) => {
				context.commit(projectType.REMOVE_PLAN, plan);
				return response;
			});
		},
	},
	types: types,
};

export default ModuleCreator("plan", PlanService, module, types, params);
